/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Readings_HintInputs */

const en_us2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the average. Gym and scale bioimpedance are only accepted from three readings up.`)
};

const pt_br2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe a média. Bioimpedância de academia e de balança só são aceitas a partir de três medições.`)
};

const es_419_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa el promedio. La bioimpedancia de gimnasio y de báscula solo se acepta a partir de tres mediciones.`)
};

const pt_pt2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica a média. A bioimpedância de ginásio e de balança só é aceite a partir de três medições.`)
};

const fr_fr2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisis la moyenne. L'impédancemétrie de salle et de balance n'est acceptée qu'à partir de trois mesures.`)
};

const de_de2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib den Mittelwert ein. Bioimpedanz aus dem Studio oder von der Waage gilt erst ab drei Messungen.`)
};

const it_it2_body_assessment_reference_readings_hint = /** @type {(inputs: Body_Assessment_Reference_Readings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la media. La bioimpedenza da palestra e da bilancia è accettata solo da tre misurazioni in su.`)
};

/**
* | output |
* | --- |
* | "Enter the average. Gym and scale bioimpedance are only accepted from three readings up." |
*
* @param {Body_Assessment_Reference_Readings_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_readings_hint = /** @type {((inputs?: Body_Assessment_Reference_Readings_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Readings_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_readings_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_readings_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_readings_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_readings_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_readings_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_readings_hint(inputs)
	return en_us2_body_assessment_reference_readings_hint(inputs)
});
export { body_assessment_reference_readings_hint as "body-assessment.reference_readings_hint" }